import React from "react";
import Main from "../../containers/_collection_details/Main/Main";
import SideSection from "../../containers/_collection_details/SideSection/SideSection";
import Layout from "../../shared/Layout/Layout";
import styles from "./CollectionDetails.module.scss";

const CollectionDetails = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <SideSection />
          <Main />
        </div>
      </div>
    </Layout>
  );
};

export default CollectionDetails;
